<template>
  <section>
    <PublicNavigation />
    <div class="container">
      <section class="job-ad">
        <div class="row">
          <div class="col-md-8">
            <span key="" @click="() => this.$router.push({ name: 'search-jobs' })" class="to-jobs"
              >Back to jobs list</span
            >
            <h1>{{ singleJob.title || 'Placeholder' }}</h1>

            <span class="employment"
              ><i class="fas fa-building"></i> {{ singleJob.employer_name }}</span
            >
            <span v-if="singleJob.address" class="type"
              ><i class="fas fa-map-marker-alt"></i> {{ singleJob.address.city.name }},
              {{ singleJob.address.country.name }}</span
            >
            <span class="employment"
              ><i class="fas fa-handshake"></i>
              {{ employmentType(singleJob.employment_type) }}</span
            >
            <span class="employment"
              ><i class="fas fa-briefcase"></i> {{ showWorkPlace(singleJob.workplace) }}</span
            >

            <hr />
            <div v-html="singleJob.description"></div>
          </div>
          <div class="col-md-4">
            <div class="box sticky-top">
              <button id="public-apply" @click="openModal" class="btn btn-success btn-block">
                Apply Now
              </button>
              <div
                v-if="singleJob.more_openings && singleJob.more_openings.length > 0"
                class="hide-on-mobile"
              >
                <h3>More Openings</h3>
                <ul class="list-unstyled">
                  <li v-for="opening in singleJob.more_openings" :key="opening.id">
                    <router-link
                      :to="{
                        name: 'preview-job-ad',
                        params: { slug: opening.slug },
                      }"
                      class="d-flex flex-wrap"
                      ><span>{{ opening.title }}</span>
                      <span
                        >{{ opening.address.city.name }}, {{ opening.address.country.name }}</span
                      ></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Job location Modal -->
        <!-- End job location Modal -->
      </section>
    </div>
    <!-- Middle Orange Section -->
    <section class="mid-section">
      <div class="container">
        <h2>A better way to match candidates and employers</h2>
        <p>
          We connect IT professionals with job opportunities from the best employers. And, because
          we believe that advertising should be free, employers can post their vacancies at no cost
          and choose from additional boosters to supercharge their ad.
        </p>
        <div class="d-flex justify-content-around mobile-wrap">
          <div class="text-box d-flex">
            <img src="../../public/img/homepage/icon-user.png" alt="user" />
            <div class="text">
              <h3>Job seekers</h3>
              <p>
                Register an account and receive job opportunities that are tailored to your skills
                and goals.
              </p>
            </div>
            <router-link to @click.native="openModal" id="register-link"
              ><i class="fas fa-angle-double-right"></i
            ></router-link>
          </div>

          <div class="text-box d-flex">
            <img src="../../public/img/homepage/icon-resume.png" alt="user resume" />
            <div class="text">
              <h3>Employers</h3>
              <p>
                Post jobs for free and boost their effectiveness with additional services for even
                better matching.
              </p>
            </div>
            <router-link to @click.native="openModal" id="register-link"
              ><i class="fas fa-angle-double-right"></i
            ></router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- End of orange section -->
    <!-- Brands Sections -->
    <section class="brands">
      <div class="container">
        <h3>Top hiring companies</h3>
        <carousel
          :autoplay="true"
          :nav="false"
          :items="8"
          :margin="40"
          :responsive="{
            0: { items: 2, nav: false },
            576: { items: 3, nav: false },
            768: { items: 3, nav: false },
            992: { items: 4, nav: false },
            1200: { items: 7, nav: false },
          }"
        >
          <img
            v-for="brand in brands"
            :key="brand.id"
            class="lgx-logo-img"
            :src="require(`../../public/img/homepage/customer-logos/${brand.src}`)"
            style="max-width: 350px; max-height: 350px"
            :alt="brand.alt"
            :title="brand.alt"
          />
        </carousel>
      </div>
    </section>
    <!-- End Brands Section -->
    <!-- Footer -->
    <Footer />
    <!-- End footer -->

    <CustomMainModal @close="showModal = false" v-show="showModal">
      <template v-slot:header>
        <h5>{{ modalTitle }}</h5>
      </template>
      <Signin v-if="showLogin" @go-to-register="openModal" @go-to-reset-password="openModal" />
      <Register
        :id="singleJob.id"
        v-if="showRegister"
        @go-to-login="openModal"
        @close="showModal = false"
        @emailVerification="(openEmailVerification = true), (showRegister = false)"
        @set-email="email => (currentEmail = email)"
        :haveTerms="false"
        leftButton="Next"
        rightButton="Cancel"
      />
      <ResetPassword v-if="showResetPassword" @close="showModal = false" />
      <VerificationCode
        v-if="openEmailVerification"
        @prevStep="(showRegister = true), (openEmailVerification = false)"
        :currentEmail="currentEmail.email"
      />
    </CustomMainModal>
    <Spinner :isLoading="isLoading" />
  </section>
</template>

<script>
import axios from 'axios';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode';

import carousel from 'vue-owl-carousel';
import PublicNavigation from '../components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import titleMixin from '../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return this.singleJob.title;
  },
  jsonLd() {
    return {
      '@context': 'https://schema.org/',
      '@type': 'JobPosting',
      title: this.singleJob.title,
      description: this.singleJob.description,
      identifier: {
        '@type': 'PropertyValue',
        name: 'Jobshark',
        value: this.$route.params.jobad_id,
      },
      datePosted: this.singleJob.published_date,
      validThrough: this.singleJob.published_date
        ? this.formatPublishDate(this.singleJob.published_date)
        : '',
      employmentType: this.employmentType(this.singleJob.employment_type),
      hiringOrganization: {
        '@type': 'Organization',
        name: this.singleJob.employer_name,
        sameAs: this.singleJob.employer_website ? this.singleJob.employer_website : '',
        logo: this.singleJob.photo
          ? `https://jobshark.eu/storage/employers/logos/${this.singleJob.photo}`
          : '',
      },
      jobLocation: {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          streetAddress: this.city,
          addressCountry: this.country,
        },
      },
    };
  },
  components: {
    CustomMainModal,
    Signin,
    Register,
    ResetPassword,
    VerificationCode,
    PublicNavigation,
    carousel,
    Footer,
  },
  data: () => ({
    modalTitle: '',
    isLoading: true,
    showModal: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
    country: '',
    city: '',
    singleJob: [],
    publishDate: '',
    validDate: '',
    brands: [
      {
        id: 0,
        src: 'Academedia.png',
        alt: 'Academedia',
      },
      {
        id: 1,
        src: 'Addedo.png',
        alt: 'Addedo',
      },
      {
        id: 2,
        src: 'Allihoopa.png',
        alt: 'Allihoopa',
      },
      {
        id: 3,
        src: 'AXS.png',
        alt: 'AXS',
      },
      {
        id: 4,
        src: 'Barium.png',
        alt: 'Barium',
      },
      {
        id: 5,
        src: 'Blogg.se.png',
        alt: 'Blog.se',
      },
      {
        id: 6,
        src: 'Bokio-1024x380.png',
        alt: 'Bokio',
      },
      {
        id: 7,
        src: 'Bygghemma.png',
        alt: 'Bygghemma',
      },
      {
        id: 8,
        src: 'Carestream.png',
        alt: 'Carestream',
      },
      {
        id: 9,
        src: 'CellaVision.png',
        alt: 'CellaVision',
      },
      {
        id: 10,
        src: 'Challengermode.png',
        alt: 'Challengermode',
      },
      {
        id: 11,
        src: 'Ciber.png',
        alt: 'Ciber',
      },
      {
        id: 12,
        src: 'City_network-1024x187.png',
        alt: 'City Network',
      },
      {
        id: 13,
        src: 'Collectum.png',
        alt: 'Collectum',
      },
      {
        id: 83,
        src: 'Cygni_new.png',
        alt: 'Cygni_new',
      },
      {
        id: 14,
        src: 'Diakrit.png',
        alt: 'Diakrit',
      },
      {
        id: 15,
        src: 'ELITS.png',
        alt: 'Elits',
      },
      {
        id: 16,
        src: 'Enklare-1024x279.png',
        alt: 'Enklare',
      },
      {
        id: 17,
        src: 'ESRI.png',
        alt: 'ESRI',
      },
      {
        id: 18,
        src: 'Etraveli.png',
        alt: 'Etraveli',
      },
      {
        id: 19,
        src: 'Filimundus.png',
        alt: 'Filimundus',
      },
      {
        id: 20,
        src: 'Flowscape.png',
        alt: 'Flowscape',
      },
      {
        id: 21,
        src: 'Footway.png',
        alt: 'Footway',
      },
      {
        id: 22,
        src: 'Freedom_finance.png',
        alt: 'Freedom finance',
      },
      {
        id: 23,
        src: 'Gavagai.png',
        alt: 'Gavagai',
      },
      {
        id: 24,
        src: 'Gears_of_leo.png',
        alt: 'Gears of leo',
      },
      {
        id: 25,
        src: 'Gimi-1024x452.png',
        alt: 'Gimi',
      },
      {
        id: 26,
        src: 'Greatdays.png',
        alt: 'Greatdays',
      },
      {
        id: 27,
        src: 'Hemverket.png',
        alt: 'Hemverket',
      },
      {
        id: 28,
        src: 'INBooks-1024x328.png',
        alt: 'Inbooks',
      },
      {
        id: 29,
        src: 'Knightec.png',
        alt: 'Knightec',
      },
      {
        id: 30,
        src: 'Lysa.png',
        alt: 'Lysa',
      },
      {
        id: 31,
        src: 'MAG_Interactive.png',
        alt: 'Mag interactive',
      },
      {
        id: 32,
        src: 'Molnify.png',
        alt: 'Molnify',
      },
      {
        id: 33,
        src: 'Nyheter24.png',
        alt: 'Nyheter24',
      },
      {
        id: 34,
        src: 'Outnorth.png',
        alt: 'Outhnorth',
      },
      {
        id: 35,
        src: 'Outpost24.png',
        alt: 'Outpost24',
      },
      {
        id: 36,
        src: 'Phonera.png',
        alt: 'Phonera',
      },
      {
        id: 37,
        src: 'Q-Park.png',
        alt: 'Q-park',
      },
      {
        id: 38,
        src: 'Quickspin-1024x246.png',
        alt: 'Quickspin',
      },
      {
        id: 39,
        src: 'Savelend.png',
        alt: 'Savelend',
      },
      {
        id: 40,
        src: 'Seliro.png',
        alt: 'Seliro',
      },
      {
        id: 41,
        src: 'Sigma_Technology.png',
        alt: 'Sigma Technology',
      },
      {
        id: 42,
        src: 'Starweb.png',
        alt: 'Starweb',
      },
      {
        id: 43,
        src: 'Swesharp.png',
        alt: 'Swesharp',
      },
      {
        id: 44,
        src: 'System_verification.png',
        alt: 'System verification',
      },
      {
        id: 45,
        src: 'Telavox-1024x410.png',
        alt: 'Telavox',
      },
      {
        id: 46,
        src: 'Tradedoubler-1024x123.png',
        alt: 'Tradedoubler',
      },
      {
        id: 47,
        src: 'Zmarta.png',
        alt: 'Zmarta',
      },
    ],
    currentEmail: '',
  }),
  methods: {
    openModal(e) {
      this.showModal = true;
      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        this.modalTitle = 'Register';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Register';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'public-apply') {
        this.modalTitle = 'Apply for Job';
        this.showRegister = true;
        this.showResetPassword = false;
        this.showLogin = false;
      }
    },
    getSingleJob() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/externalpages/index/${this.$route.params.slug}`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          if (data.length === 0) {
            this.$router.push({ name: 'search-jobs' });
            return false;
          }
          this.singleJob = data;
          this.city = data.address.city.name;
          this.country = data.address.country.name;
          document.title = `${this.singleJob.title} | Jobshark`;
          this.isLoading = false;
          this.updateMeta();
        })
        .catch(({ error }) => {
          this.isLoading = false;
        });
    },
    formatPublishDate(dateString) {
      const date = new Date(dateString);
      date.setMonth(date.getMonth() + 1);
      function formatDateToISOString(date) {
        return date.toISOString().split('.')[0] + 'Z';
      }
      const newDateString = formatDateToISOString(date);
      return newDateString;
    },
    employmentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
  },
  mounted() {
    this.getSingleJob();
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.container {
  max-width: 1320px;
}
.main-header {
  height: 70vh;
  background: url('../../public/img/homepage/header_home.png');
  background-size: cover;
  margin-top: 70px;
  .container {
    height: 70vh;
    flex-wrap: wrap;
    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;
      span {
        display: block;
      }
    }
    .form-inline {
      width: 100%;
      .form-group {
        position: relative;
        &:first-of-type {
          width: 50%;
          margin-right: 15px;
        }
        &:nth-of-type(2) {
          width: 30%;
          margin-right: 15px;
        }
        &:nth-of-type(3) {
          flex: 1;
        }
        i {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 12px;
          color: #9b9b9b;
          font-size: 26px;
        }
        .form-control {
          border-radius: 8px;
          min-height: 65px;
          flex: 1;
          font-size: 18px;
          font-family: $font-family-sans-lato;
        }
        .btn-secondary {
          height: 65px;
          border-radius: 8px;
          display: block;
          width: 100%;
          text-transform: uppercase;
        }
      }
      a {
        display: block;
        color: #fff;
        text-decoration: none;
        font-size: 18px;
        margin-top: 10px;
      }
    }
  }
}

.latest-ads {
  padding: 60px 0;
  h2 {
    text-transform: uppercase;
    font-size: 21px;
    margin-bottom: 40px;
  }
  .single {
    padding: 5px;
    background: #fff;
    box-shadow: 0px 15px 35px #0000000d;
    margin-bottom: 20px;
    font-family: $font-family-sans-lato;
    img {
      width: 70px;
      height: 70px;
      object-fit: cover;
      object-position: center;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
    }
    .job-info {
      width: 37%;
      margin-right: 12px;
      a {
        display: block;
        text-decoration: none;
        &:first-of-type {
          font-size: 18px;
        }
        &:nth-of-type(2) {
          color: #424242;
          font-size: 16px;
        }
      }
    }
    .location {
      text-align: center;
      width: 130px;
      margin: 0 10px;
      a {
        text-decoration: none;
      }
      i {
        display: block;
        color: #afafaf;
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
      }
    }
    .tagline {
      text-align: right;
      width: 200px;
      a {
        display: inline-block;
        background: #f2f2f2;
        border-radius: 16px;
        color: #3e3e3e;
        border: 5px solid #fff;
        font-size: 13px;
        padding: 3px 8px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
}
.pagination {
  a {
    color: #495057;
    font-size: 14px;
  }
}

.single-promoted {
  padding: 5px;
  background: #fff;
  box-shadow: 0px 15px 35px #0000000d;
  margin-bottom: 20px;
  font-family: $font-family-sans-lato;
  position: relative;
  img {
    width: 70px;
    height: 70px;
    flex-shrink: 0;
  }
  .single-job-info {
    margin-left: 12px;
    flex-wrap: wrap;
    span {
      &:first-of-type {
        display: block;
        width: 100%;
        a {
          text-decoration: none;
        }
      }
      &:nth-of-type(2) {
        display: block;
        a {
          color: #87859c;
          font-size: 14px;
          text-decoration: none;
        }
      }
    }
  }
  .location {
    position: absolute;
    top: 13px;
    right: 5px;
    font-size: 12px;
    color: #87859c;
  }

  .details {
    position: absolute;
    bottom: 13px;
    right: 5px;
    a {
      font-size: 12px;
      text-decoration: none;
    }
  }
}

.mid-section {
  padding: 60px 0;
  background: hsl(23, 100%, 47%);
  color: #fff;
  margin-bottom: 40px;
  img {
    width: 56px;
    height: 65px;
    flex-shrink: 0;
    margin: 20px 20px 0 0;
  }
  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
  }
  p {
    text-align: center;
    font-family: $font-family-sans-lato;
    font-size: 18px;
  }
  .text-box {
    margin-top: 80px;
    width: 300px;
    position: relative;
    .text {
      h3 {
        text-transform: uppercase;
        font-size: 24px;
      }
      p {
        text-align: left;
        font-family: $font-family-sans-lato;
        font-size: 16px;
      }
    }
    a {
      position: absolute;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      line-height: 40px;
      background: #424242;
      color: #fff;
      text-decoration: none;
      text-align: center;
      top: 50%;
      right: -35px;
      transform: translate(0, -50%);
    }
  }
}

.brands {
  padding: 50px 0;
  h3 {
    text-transform: uppercase;
    text-align: center;
    font-size: 34px;
    margin-bottom: 50px;
  }
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}

.footer {
  width: 100%;
  height: 350px;
  background: url('../../public/img/homepage/footer-bg.png');
  background-size: cover;
  text-transform: uppercase;
  color: #fff;
  a {
    text-decoration: none;
    color: #fff;
  }
  .list-inline {
    li {
      position: relative;
      margin-right: 25px;
      font-size: 14px;
      &:after {
        content: '';
        position: absolute;
        right: -13px;
        top: 0;
        width: 1px;
        height: 100%;
        background: #fff;
      }
      &.last {
        &:after {
          display: none;
        }
      }
    }
  }
}

@media only screen and (max-width: 992px) {
}

@media only screen and (max-width: 768px) {
  .main-header {
    height: auto;
    .container {
      height: auto;
      padding: 30px 20px;
      h1 {
        font-size: 2rem;
      }
      .form-inline {
        .form-group {
          width: 100% !important;
          margin: 12px 0px;
          &:first-of-type {
            width: 100%;
          }
          .form-control {
            min-height: 55px;
          }
          .btn-secondary {
            height: 55px;
          }
        }
      }
      a {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .main-header {
    margin-top: 60px;
  }
  .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(2) {
          text-align: right;
        }
      }
    }
  }
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
  }
}
.job-ad {
  padding: 80px 0 80px 0;
  .to-jobs {
    display: block;
    margin: 20px 0 12px 0;
    font-weight: 700;
    font-size: 14px;
    text-decoration: none;
    color: #0088cc;
    cursor: pointer;
  }
  font-family: $font-family-sans-lato;
  h1 {
    font-size: 32px;
    font-weight: 700;
    margin: 15px 0 12px 0;
  }
  .location,
  .employment,
  .type {
    margin-right: 20px;
    font-size: 14px;
    i {
      color: #777;
      margin-right: 5px;
    }
    a {
      text-decoration: none;
    }
  }
  .last {
    display: none;
  }
  .list-unstyled {
    list-style: circle;
    margin: 15px 0;
    li {
      margin-left: 20px;
      padding-left: 8px;
    }
  }
  .company-info {
    font-style: italic;
  }
  .btn-success {
    margin: 52px 0 12px 0;
    font-weight: 700;
    padding: 12px 0;
    font-size: 18px;
  }
  .box {
    margin-top: 55px;
    .list-unstyled {
      list-style: none;
      li {
        margin: 0 0 12px 0;
        padding: 0;
        a {
          text-decoration: none;
          span {
            &:first-of-type {
              font-size: 18px;
              font-family: 'Lato', sans-serif;
              width: 100%;
            }
            &:nth-of-type(2) {
              font-size: 12px;
              color: #424242;
            }
          }
        }
      }
    }
    h3 {
      text-transform: uppercase;
      font-size: 18px;
      margin: 25px 0 12px 0;
      font-family: Montserrat, sans-serif;
    }
  }
}
.map-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.map-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

.copyright {
  margin-bottom: 30px;
  svg {
    width: 60px;
    height: 50px;
  }
  .text {
    text-align: center;
    span:first-of-type {
      display: block;
      font-size: 13px;
    }
    span:nth-of-type(2) {
      font-weight: 700;
      font-size: 14px;
      text-transform: uppercase;
    }
  }
}

@media only screen and (max-width: 576px) {
  .hide-on-mobile {
    display: none;
  }
  .job-ad {
    position: relative;
    .last {
      display: inline-block;
    }
  }
  .box {
    background: #fff;
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0 auto;
    padding: 6px 22px;
    .list-unstyled {
      display: none;
    }
    p {
      display: none;
    }
    .btn-block {
      margin: 6px auto !important;
    }
  }
  .copyright {
    margin-bottom: 80px;
  }
}
.sticky-top {
  top: 120px;
}
</style>
